module.exports = __webpack_public_path__ + "img/omar-thumb.7066b08d.jpg";